import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';

import SubjectForm from './SubjectForm';
import {
  fetchCorrelativasPorMateriaMalla,
  saveCorrelativa,
  deleteCorrelativa,
} from '../../../redux/actions/correlativaActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import Confirm from '../../../shared/components/Confirm';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import { apiGet } from '../../../api/index';
import { urlMaterias } from '../../../api/urls';

class SubjectFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      materia: null,
      correlativas: [],
      materiasDisponibles: [],
      loading: true,
      materiaCorrelativaSeleccionada: null,
    };

    this.handleDeleteCorrelativa = this.handleDeleteCorrelativa.bind(this);
    this.handleAddCorrelativa = this.handleAddCorrelativa.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentDidMount() {
    this.fetchCurrentMateria();
  }

  fetchCurrentMateria = () => {
    const { id, history } = this.props;

    if (!id) {
      history.push('/pages/subjects');
      return;
    }

    apiGet(`${urlMaterias}/materia-malla/${id}`)
      .then((materia) => {
        if (!materia || materia.error) {
          createErrorMessage('La materia no existe');
          history.push('/pages/subjects');
          return;
        }
        this.setState({ materia, loading: false });
        this.fetchCorrelativas(materia.id);
        this.fetchMateriasDisponibles(materia.id);
      })
      .catch(() => {
        createErrorMessage('Error al cargar los datos de la materia');
        this.setState({ loading: false });
      });
  }

  fetchMateriasDisponibles = (materiaMallaId) => {
    apiGet(`${urlMaterias}/materia-malla/${materiaMallaId}/disponibles`)
      .then((items) => {
        this.setState({ materiasDisponibles: Array.isArray(items) ? items : [] });
      })
      .catch(() => {
        createErrorMessage('Error al cargar las materias malla correlativas disponibles');
      });
  }

  fetchCorrelativas = (materiaMallaId) => {
    if (!materiaMallaId) return;
    fetchCorrelativasPorMateriaMalla(materiaMallaId, {
      onSuccess: (correlativas) => {
        this.setState({ correlativas: Array.isArray(correlativas) ? correlativas : [] });
      },
      onError: () => {
        createErrorMessage('Error al cargar las correlativas');
      },
    });
  }

  handleFilterChange = (field, value) => {
    this.setState({ [field]: value });
  }

  handleAddCorrelativa = (onSuccessCallback) => {
    const { materiaCorrelativaSeleccionada } = this.state;
    const { id } = this.props;
    const materiaMallaId = id ? parseInt(id, 10) : 0;

    if (!materiaMallaId) {
      createErrorMessage('No se pudo identificar la materia malla actual');
      return;
    }
    if (!materiaCorrelativaSeleccionada) {
      createWarningMessage('Debe seleccionar una materia malla correlativa');
      return;
    }

    saveCorrelativa(
      {
        materiaMallaId,
        materiaMallaCorrelativaId: materiaCorrelativaSeleccionada.value,
      },
      {
        onSuccess: () => {
          createSuccessMessage('Correlativa agregada exitosamente');
          this.fetchCorrelativas(materiaMallaId);
          this.fetchMateriasDisponibles(materiaMallaId);
          this.setState({ materiaCorrelativaSeleccionada: null }, () => {
            if (typeof onSuccessCallback === 'function') {
              onSuccessCallback();
            }
          });
        },
        onError: (error) => {
          if (error && error.message) {
            createWarningMessage(error.message);
          } else {
            createErrorMessage('Error al agregar la correlativa');
          }
        },
      },
    );
  }

  handleDeleteCorrelativa = (correlativa) => {
    Confirm({
      title: 'Eliminar correlativa',
      question: `¿Estás seguro que deseas eliminar la correlativa "${correlativa.materiaNombre}"?`,
      yesLabel: 'Sí, eliminar',
      noLabel: 'No, volver',
      onConfirm: () => {
        deleteCorrelativa(correlativa.id, {
          onSuccess: () => {
            createSuccessMessage('Correlativa eliminada exitosamente');
            const { id } = this.props;
            const materiaMallaId = id ? parseInt(id, 10) : 0;
            if (materiaMallaId) {
              this.fetchCorrelativas(materiaMallaId);
              this.fetchMateriasDisponibles(materiaMallaId);
            }
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('La correlativa no existe');
            } else {
              createErrorMessage('Error al eliminar la correlativa');
            }
          },
        });
      },
    });
  }

  handleSubmit = (values) => {
    this.setState((prevState) => {
      const { materiaCorrelativaSeleccionada } = values;
      return {
        materiaCorrelativaSeleccionada: materiaCorrelativaSeleccionada || prevState.materiaCorrelativaSeleccionada,
      };
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.push('/pages/subjects');
  }

  render() {
    const { id } = this.props;
    const {
      materia,
      correlativas,
      materiasDisponibles,
      loading,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Materias y Correlativas</h3>
            <h3 className="page-subhead subhead">
              Gestión de correlativas de la materia
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {loading || !materia
              ? <LoadingSpinner />
              : (
                <SubjectForm
                  id={id ? parseInt(id, 10) : 0}
                  nombre={materia.materia || ''}
                  codigo={materia.codigoMateria || ''}
                  notas={materia.notas || ''}
                  semestre={materia.semestre || 0}
                  malla={materia.malla || ''}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={materia}
                  correlativas={correlativas}
                  materiasDisponibles={materiasDisponibles}
                  handleDeleteCorrelativa={this.handleDeleteCorrelativa}
                  handleAddCorrelativa={this.handleAddCorrelativa}
                  onFilterChanges={this.handleFilterChange}
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

SubjectFormContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default SubjectFormContainer;
